export default __webpack_public_path__ + "static/star-rating-30d813f22a4c3a1cbe41791c804474ea.png";